var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


$().ready(function(){
  $('.sub-bg').slick({
    arrows: false,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 3.5,
        responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 399,
        settings: {
          slidesToShow: 1.5
        }
      }
    ]
  });
});


// var swiper = new Swiper(".product-list--carousel", {
//   slidesPerView: 4,
//   spaceBetween: 30,
//   freeMode: true,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
// });


$(document).ready(function(){
      $('.slick-carousel-announcement').slick({
        speed: 700,
        autoplay: true,
        autoplaySpeed: 3000,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        pauseOnHover: true
      });
});

$().ready(function(){
  $('.abz-image-slide').slick({
    arrows: false,
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 5,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});
$(document).ready(function() {
  $('.abz-slideshow .slick-slide.slick-current .feature-subheader').addClass('fade-up-animation');

  $('.abz-slideshow .slideshow').on('afterChange', function(event, slick, currentSlide) {
    $('.abz-slideshow .feature-subheader').removeClass('fade-up-animation-delay');
    $('.abz-slideshow .slick-slide[data-slick-index="' + currentSlide + '"] .feature-subheader').addClass('fade-up-animation-delay');
  });
});
$(document).ready(function() {
  $('.abz-slideshow .slick-slide.slick-current h2.line-1').addClass('fade-up-animation');

  $('.abz-slideshow .slideshow').on('afterChange', function(event, slick, currentSlide) {
    $('.abz-slideshow h2.line-1').removeClass('fade-up-animation');
    $('.abz-slideshow .slick-slide[data-slick-index="' + currentSlide + '"] h2.line-1').addClass('fade-up-animation');
  });
});
$(document).ready(function() {
  $('.abz-slideshow .slick-slide.slick-current .rte.line-2.large-text').addClass('fade-up-animation-delay');

  $('.abz-slideshow .slideshow').on('afterChange', function(event, slick, currentSlide) {
    $('.abz-slideshow .rte.line-2.large-text').removeClass('fade-up-animation-delay');
    $('.abz-slideshow .slick-slide[data-slick-index="' + currentSlide + '"] .rte.line-2.large-text').addClass('fade-up-animation-delay');
  });
});
$(document).ready(function() {
  $('.abz-slideshow .slick-slide.slick-current .line-3').addClass('fade-up-animation-delay');

  $('.abz-slideshow .slideshow').on('afterChange', function(event, slick, currentSlide) {
    $('.abz-slideshow .line-3').removeClass('fade-up-animation-delay');
    $('.abz-slideshow .slick-slide[data-slick-index="' + currentSlide + '"] .line-3').addClass('fade-up-animation-delay');
  });
});


// $('.slider').slick({
//   autoplay: true,
//   speed: 800,
//   lazyLoad: 'progressive',
//   arrows: true,
//   dots: true,
// });
// $('.slick-slider').on('afterChange', function(event, slick, currentSlide) {
//   $('.slide__content--headings h2, .slide__content--headings p').removeClass('animated').removeClass(function (index, className) {
//     return (className.match(/(^|\s)fadeIn\S+/g) || []).join(' ');
//   });
//   if ($(slick.$slides[currentSlide]).hasClass('slick-slide slick-current slick-active')) {
//     $('.slick-slide.slick-current.slick-active .slide__content--headings h2').addClass('animated').addClass('fadeInUp');
//     $('.slick-slide.slick-current.slick-active .slide__content--headings p').addClass('animated').addClass('fadeInUp').attr('data-delay', '0.8s');
//   }
// });







// $('#slick-home-slide').slick({
//   dots: true,
//   infinite: false,
//   speed: 100,
//   slidesToShow: 3,
//   arrows: false,
//   autoplay: false,
//   responsive: [
    
//     {
//       breakpoint: 821,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });